//# sourceMappingURL=theme.js.map
window.$script = function() {
  function u(t, e) {
      for (var i = 0, n = t.length; i < n; ++i)
          if (!e(t[i]))
              return a;
      return 1
  }
  function c(t, e) {
      u(t, function(t) {
          return e(t),
          1
      })
  }
  function h(t, e, i) {
      function n(t) {
          return t.call ? t() : g[t]
      }
      function o() {
          if (!--l)
              for (var t in g[a] = 1,
              s && s(),
              v)
                  u(t.split("|"), n) && !c(v[t], n) && (v[t] = [])
      }
      t = t[p] ? t : [t];
      var r = e && e.call
        , s = r ? e : i
        , a = r ? t.join("") : e
        , l = t.length;
      return setTimeout(function() {
          c(t, function t(e, i) {
              return null === e ? o() : (!i && !/^https?:\/\//.test(e) && f && (e = -1 === e.indexOf(".js") ? f + e + ".js" : f + e),
              b[e] ? (a && (y[a] = 1),
              2 == b[e] ? o() : setTimeout(function() {
                  t(e, !0)
              }, 0)) : (b[e] = 1,
              a && (y[a] = 1),
              void d(e, o)))
          })
      }, 0),
      h
  }
  function d(t, e) {
      var i, n = r.createElement("script");
      n.onload = n.onerror = n[m] = function() {
          n[l] && !/^c|loade/.test(n[l]) || i || (n.onload = n[m] = null,
          i = 1,
          b[t] = 2,
          e())
      }
      ,
      n.async = 1,
      n.src = o ? t + (-1 === t.indexOf("?") ? "?" : "&") + o : t,
      s.insertBefore(n, s.lastChild)
  }
  var f, o, r = document, s = r.getElementsByTagName("head")[0], a = !1, p = "push", l = "readyState", m = "onreadystatechange", g = {}, y = {}, v = {}, b = {};
  return h.get = d,
  h.order = function(i, n, o) {
      !function t(e) {
          e = i.shift(),
          i.length ? h(e, t) : h(e, n, o)
      }()
  }
  ,
  h.path = function(t) {
      f = t
  }
  ,
  h.urlArgs = function(t) {
      o = t
  }
  ,
  h.ready = function(t, e, i) {
      t = t[p] ? t : [t];
      var n, o = [];
      return !c(t, function(t) {
          g[t] || o[p](t)
      }) && u(t, function(t) {
          return g[t]
      }) ? e() : (n = t.join("|"),
      v[n] = v[n] || [],
      v[n][p](e),
      i && i(o)),
      h
  }
  ,
  h.done = function(t) {
      h([null], t)
  }
  ,
  h
}
function loadScript(url, callback) {
  var script = document.createElement('script');
  script.type = 'text/javascript';

  if (script.readyState) {  // IE
      script.onreadystatechange = function() {
          if (script.readyState === 'loaded' || script.readyState === 'complete') {
              script.onreadystatechange = null;
              callback();
          }
      };
  } else {  // Others
      script.onload = function() {
          callback();
      };
  }

  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
}


$(function(){
  window.body = $('body')
  const refresh_Youtube=function (_this) {
    // https://developers.google.com/youtube/iframe_api_reference
    if (!window.YT) return;
  
    var attemptedToPlay = false,
        loading = 'video_loading',
        loaded = 'video_loaded',
        interactable = 'video_interactable';
    if(!_this.data('id')) return    
    const dom = _this.find('.videoplayer')
    if(!YT){
      BGVideoSection()
      return
    } 
    var YTPlayer = new YT.Player(dom[0], {
        videoId: _this.data('id'),
        width: 1280,
        height: 720,
        playerVars: {
          // start: 10,
          // end: 15,
          iv_load_policy: 3,
          enablejsapi: 1,
          disablekb: 1,
          autoplay: 0,
          controls: 0,
          rel: 0,
          loop: 0,
          playsinline: 1,
          modestbranding: 1,
          autohide:1,
          branding: 0,
          cc_load_policy: 0,
          fs: 0,
          quality: 'hd1080',  //hd1080, hd720
          wmode: "transparent"
        },
        events: {
          onReady: onPlayerReady,
          onStateChange: onPlayerStateChange
        }
    });
    if(_this.hasClass("main-video")){
      const sectionId = _this.data('sectionId')
      window[sectionId] = YTPlayer
    }
  
    function onPlayerReady(evt) {
      // evt.target.setPlaybackQuality('hd1080');
      // evt.target.setPlaybackQuality('hd1080').playVideo().mute();
      //if ( _this.hasClass('unmute_false') ) {evt.target.mute();}
      if(_this.attr("data-autoplay")==="false") return
      YTPlayer.setPlaybackQuality('hd1080').playVideo().mute();
    }
    
    function onPlayerStateChange(evt) {
        // if (evt.data == YT.PlayerState.BUFFERING) {
        //     evt.target.setPlaybackQuality('hd720');
        // }
        // if (evt.data == 1) {
        //   _this.addClass('video_playing')
        // }
        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (attemptedToPlay) {
              //alert('adu');
              $('.img_vid_js:not(.lazyloadt4sed)').addClass('lazyloadt4s');
              setVideoLoaded(_this);
              setVideoInteracted(_this);
            }
            break;
          case 0: // ended
            // evt.target.playVideo();
            // console.log(YTPlayer)
  
            // YTPlayer.loadVideoById({
            //   videoId: _this.data('id'),
            //   startSeconds: 10,
            //   endSeconds: 15,
            //   suggestedQuality: 'hd1080'
            // });
  
            YTPlayer.playVideo();
            break;
          case 1: // playing
            setVideoLoaded(_this);
            break;
          case 3: // buffering
            attemptedToPlay = true;
            YTPlayer.setPlaybackQuality('hd1080');
            break;
        }
        //console.log(evt.data)
    }
  
    var setVideoLoading = function(el) {
      el.addClass(loading);
    };
  
    var setVideoLoaded = function(el) {
      el.removeClass(loading).removeClass(interactable).addClass(loaded);
    };
  
    var setVideoInteracted = function(el) {
      el.addClass(interactable);
    };
  }
  function BGVideoSection (){   
    if ($('.js_video').length == 0 ) return;
    
    var yt_src = '//www.youtube.com/iframe_api';
    $script(yt_src, 'loaded_v_js');
    // 使用示例
    loadScript(yt_src, function() {
      // 这里是在脚本加载完成后执行的回调函数
      $('.js_video').each(function (index) {
        //console.log('index: '+index);
        const _this=$(this)
        setTimeout(function(){
          refresh_Youtube(_this);
        },500) 
      });
    });
  /*   body.on('youTubeReady', function() {
      console.log($('.js_video'))
        $('.js_video').each(function (index) {
          //console.log('index: '+index);
          refresh_Youtube($(this));
        });
    }); */
  }
  BGVideoSection()

  const handleAddQuantity = (quantityInput) => {
    const currentValue = parseInt(quantityInput.value);
    const newValue = currentValue + 1;
    quantityInput.value = newValue;
    quantityInput.dispatchEvent(new Event('change'));
  };

  const handleSubtractQuantity = (quantityInput) => {
    const currentValue = parseInt(quantityInput.value);
    if (currentValue === 1) return;
    const newValue = currentValue - 1;
    quantityInput.value = newValue;
    quantityInput.dispatchEvent(new Event('change'));
  };

  $("body").on('click',".product-data-add-quantity",function(){
    const quantityWrapper = $(this).parents(".product__info__details")
    console.log(quantityWrapper)
    if(!quantityWrapper) return
    const quantityInput = quantityWrapper.find(".product__input--quantity")
    const quantityInput1 = quantityWrapper.find(".product-form__input--quantity")
    handleAddQuantity(quantityInput[0])
    handleAddQuantity(quantityInput1[0])
  })
  $("body").on('click',".product-data-subtract-quantity",function(){
    const quantityWrapper = $(this).parents(".product__info__details")
    if(!quantityWrapper) return
    const quantityInput = quantityWrapper.find(".product__input--quantity")
    const quantityInput1 = quantityWrapper.find(".product-form__input--quantity")
    handleSubtractQuantity(quantityInput[0])
    handleSubtractQuantity(quantityInput1[0])
  })

  
  $("body").on('click',".new-add-btn",async function(event){
    let variantQuantity = '';
    var variantId = '';
    const formData = $(this).parents(".product-form").serializeArray();
    $.each(formData, function(i, field){
      switch(field.name) {
        case 'quantity':
          variantQuantity = field.value;
          break;
        case 'id':
          variantId = field.value;
          break;
        default:
      }
    });
    event.preventDefault();
    const _this = $(this)
    $(this).addClass("iconfont loading-inner")
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id:variantId,
        quantity:variantQuantity
      })
    }).then(() => {
      if(window.quickCart){
        window.quickCart?.updateCart(()=>{
          _this.parents(".fullscreenPopup").fadeOut()
          setTimeout(function(){
            _this.removeClass("iconfont loading-inner")
          },200)
        });
       /*  window.quickCart?.open(); */
      }
    });
  })
})